import _objectSpread from "/Users/boji/Documents/leyue/association-admin-vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/boji/Documents/leyue/association-admin-vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { createRouter, createWebHistory } from "vue-router";
import store from '@/store';
import { constantRoutes } from './config';
import NProgress from 'nprogress';
import { removeToken, getToken } from '@/utils/auth'; // browser's progress bar

NProgress.configure({
  showSpinner: false
});
var router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
});
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var newTitle, currentToken, menus, _yield$store$dispatch, allMenus;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            NProgress.start();
            newTitle = (to.meta.title || '') + ' - ' + process.env.VUE_APP_TITLE;

            if (!(to.path === '/login')) {
              _context.next = 7;
              break;
            }

            next();
            document.title = newTitle;
            NProgress.done();
            return _context.abrupt("return");

          case 7:
            currentToken = getToken();

            if (!currentToken) {
              _context.next = 21;
              break;
            }

            menus = store.getters.menus;

            if (!(menus && menus.length)) {
              _context.next = 14;
              break;
            }

            next(); // next({ ...to, replace: true }) 

            _context.next = 19;
            break;

          case 14:
            _context.next = 16;
            return store.dispatch('account/getMenusPhp');

          case 16:
            _yield$store$dispatch = _context.sent;
            allMenus = _yield$store$dispatch.menus;

            if (allMenus && allMenus.length) {
              next(_objectSpread(_objectSpread({}, to), {}, {
                replace: true
              }));
            } else {
              removeToken();
              next('/login');
            }

          case 19:
            _context.next = 23;
            break;

          case 21:
            removeToken();
            next('/login');

          case 23:
            document.title = newTitle;
            NProgress.done();

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
export function resetRouter() {
  var newRouter = createRouter({
    history: createWebHistory(),
    routes: constantRoutes
  });
  return newRouter;
}
export default router;